export default __webpack_public_path__ + "static/media/user-icon.f34d66b1.svg";